import { useEffect, useState ,useContext } from "react";
import Select from "../../Form/Select";
import FiltriAvanzati from "../../Utility/FiltriAvanzati/FiltriAvanzati";
import { useLocation, useNavigate } from "react-router-dom";
import Card from "../../Utility/Card/Card";
import { RichiestaService } from "../../../services/RichiestaService";
import { BandoService } from "../../../services/BandoService";
import { FormUtility } from "../../Utility/FormUtility";
import ToastContext from '../../../contexts/toast';
import Modal from "../../Utility/Modal/Modal";
import AlertMessage from "../../Utility/Alert/AlertMessage";
import moment from 'moment';

const Dashboard = () => {
  const [richieste, setRichieste] = useState([]);

  const [currMapFilters, setCurrMapFilters] = useState(null);
  const [nextMapFilters, setNextMapFilters] = useState(null);
  const [advancedFiltersMap, setAdvancedFiltersMap] = useState(null);
  const [nextAdvancedFiltersMap, setNextAdvancedFiltersMap] = useState(null);

  const [firstLoad, setFirstLoad] = useState(false);

  const [annoScolastico, setAnnoScolastico] = useState(null);
  const [esito, setEsito] = useState(null);
  const toastContext = useContext(ToastContext);
  const [anniScolastici, setAnniScolastici] = useState(null);
  const [canCreate, setCanCreate] = useState(false);

  const [isModalOpen, setModalOpen] = useState(false);
  const [title, setTitle] = useState(null);
  const [content, setContent] = useState(null);
  const [icona, setIcona] = useState(null);
  const [iconaColor, setIconaColor] = useState(null);

  const [richiestaId, setRichiestaId] = useState(null);
  const [inDelete, setInDelete] = useState(false);
  const [closeLabel, setCloseLabel]=useState('Annulla');
  const [showIcon, setShowIcon] = useState(false);
  const [hideActionButton, setHideActionButton] = useState(false);
  const [canCreateLoaded, setCanCreatedLoaded] = useState(false);
  const [richiesteLoaded, setRichiesteLoaded] = useState(false);
  const [onCreateRichiesta, setOnCreateRichiesta] = useState(false);

  const [fasi, setFasi] = useState([]);

  const esiti = [
    { value: 'Bozza', key: 'BOZZA' },
    { value: 'Presentata', key: 'PRESENTATA' },
    { value: 'Rettificata', key: 'AGGIORNATA'},
    { value: 'Idonea', key: 'IDONEA'},
    { value: 'Non Idonea', key: 'NON_IDONEA'},
    { value: 'Rinunciata', key: 'RINUNCIATA'},
    { value: 'Aggiornata', key: 'AGGIORNATA_SA'},
    { value: 'Sospesa', key: 'SOSPESA_TERZO_ACCESSO'},
    { value: "Ammessa al contributo", key: 'AMMESSA_CONTRIBUTO' },
    { value: "Non ammessa al contributo", key: 'NON_AMMESSA_CONTRIBUTO' },
    { value: "Contributo erogato", key: 'CONTRIBUTO_EROGATO' },
    { value: "Annullata", key: 'ANNULLATA' }
  ];

  const location = useLocation();
  const navigation = useNavigate();

  const bandoService = new BandoService();
  const richiestaService = new RichiestaService();
  const utility = new FormUtility();
  
  /*setRichieste( [
        {
            id:1,stato:'accettata',codice:'LG25000001',data:'2025-02-28',cognome:'Verdi',nome:'Giuseppe'
        },
        {
            id:2,stato:'bozza',codice:'LG25000002',data:'2025-03-02',cognome:'Manzoni',nome:'Alessandro'
        }
    ]);*/

  useEffect(() => {
    setCanCreatedLoaded(false);
    richiestaService.canCreateNewRequest().then((resp) => {
      setCanCreate(resp);
      setCanCreatedLoaded(true);
    }).catch(error => {
      console.log(error);
      setCanCreatedLoaded(true);
    });

    bandoService.getAll().then((resp) => {
      setFasi([ ...resp ].flatMap(bando => bando.fasi));
      setAnniScolastici([...resp].map(str => ({
        key: str.annoEducativo,
        value: str.annoEducativo
      })));
    });
  }, []);

  useEffect(() => {
    if (firstLoad) {
      return;
    }

    const filtri = utility.getFiltriAvanzatiStorage(location, '_filtri_avanzati');
    setOnLoadFiltriAvanzatiFromStorage(filtri);
    setNextMapFilters(filtri ? new Map(Object.entries(filtri)) : new Map());
    setCurrMapFilters(filtri ? new Map(Object.entries(filtri)) : new Map());

    setFirstLoad(true);
  }, [firstLoad]);

  const setOnLoadFiltriAvanzatiFromStorage = (filtri) => {
    const filtriAvanzati = advancedFiltersMap ?? new Map();
    const proxMappaFiltri = new Map(nextMapFilters);
    const proxMappaFiltriAvanzati = new Map(nextAdvancedFiltersMap);

    for (const key in filtri) {
      const value = filtri[key];

      let filterValue = value;
      let filtroAvanzato = value;
      switch (key) {
        case 'Esito':
          filterValue = esiti.find(el => el.value === value)?.key;
          break;
        default:
          break;
      }

      onChangeFilter(key, filterValue, proxMappaFiltri, proxMappaFiltriAvanzati, false);
      filtriAvanzati.set(key, filtroAvanzato);
    }

    setNextAdvancedFiltersMap(new Map(filtriAvanzati));
    setAdvancedFiltersMap(new Map(filtriAvanzati));
  };

  const setFiltriAvanzatiInStorage = (mapFilters) => {
    const obj = Object.fromEntries(mapFilters);
    sessionStorage.setItem(
      `${location.pathname}_filtri_avanzati`,
      JSON.stringify(obj)
    );
  }

  const onChangeFilter = async (type, val, mappaFiltri, mappaFiltriAvanzati, updateNextMap = true, updateMap = false) => {
    let mapValue = val;
    let mapAvanzatoValue = val;

    switch (type) {
      case 'Anno Scolastico':
        setAnnoScolastico(val);
        break;
      case 'Esito':
        mapValue = esiti.find(e => e.key === val)?.value;
        setEsito(val);
        break;
      default:
        break;
    }

    if (!mapValue) {
      mappaFiltri.delete(type);
      mappaFiltriAvanzati.delete(type);
    } else {
      mappaFiltri.set(type, mapValue);
      mappaFiltriAvanzati.set(type, mapAvanzatoValue);
    }

    if (updateNextMap) {
      setNextMapFilters(new Map(mappaFiltri));
      setNextAdvancedFiltersMap(new Map(mappaFiltriAvanzati));
    }

    if (!updateMap) {
      return;
    }

    setCurrMapFilters(new Map(mappaFiltri));
    setAdvancedFiltersMap(new Map(mappaFiltriAvanzati));
    setFiltriAvanzatiInStorage(new Map(mappaFiltri));
  };

  useEffect(() => {
    if (!firstLoad || !currMapFilters) {
      return;
    }

    getRichieste();
  }, [currMapFilters]);

  const onSearch = async() => {
    setCurrMapFilters(new Map(nextMapFilters));
    setAdvancedFiltersMap(new Map(nextAdvancedFiltersMap));
    setFiltriAvanzatiInStorage(nextMapFilters);
  }

  const eliminaRichiesta = (richiesta) => {
    setRichiestaId(richiesta.id);
    setTitle('Elimina domanda');
    setIcona(null);
    setIconaColor(null);
    setContent('Confermi di voler eliminare la domanda in bozza?\nAttenzione: una volta eliminata non sarà più possibile recuperarla o completarla');
    setCloseLabel('Annulla');
    setShowIcon(false);
    setHideActionButton(false);
    setModalOpen(true);
  };

  const rinunciaRichiesta = (richiesta) => {
    setRichiestaId(richiesta.id);
    setTitle('Rinuncia domanda');
    setIcona(null);
    setIconaColor(null);
    setContent('Attenzione! A seguito della rinuncia, la domanda non verrà ammessa al beneficio per l’A.S. ' + richiesta.annoEducativo + ' e non sarà possibile per lo studente presentare una nuova domanda per l’A.S. ' + richiesta.annoEducativo + ' in caso di riapertura dei termini previsti dal bando (rif. Art. 13). Conferma di rinunciare al contributo per la domanda ' + richiesta.codice + '?');
    setCloseLabel('Annulla');
    setShowIcon(false);
    setHideActionButton(false);
    setModalOpen(true);
  };

  const handleModalAction = () => {
    setInDelete(true);
    const ric = richieste.find(x => x.id === richiestaId);
    const statoRichiesta = ric?.statoRichiesta;
    switch (statoRichiesta?.toLowerCase()) {
      case 'bozza':
        richiestaService
          .delete(richiestaId)
          .then(() => {
            getRichieste();
            toastContext.success('Domanda eliminata con successo!', 6000);
            setModalOpen(false);
            setRichiestaId(null);
            setInDelete(false);
          })
          .catch((error) => {
            toastContext.error(utility.getErrorMsg(error), 12000);
            setInDelete(false);
          });
        break;
      case 'presentata':
      case 'aggiornata':
        richiestaService
          .annullaDomanda(richiestaId)
          .then(() => {
            getRichieste();
            toastContext.success('Domanda annullata con successo!', 6000);
            setModalOpen(false);
            setRichiestaId(null);
            setInDelete(false);
          })
          .catch((error) => {
            toastContext.error(utility.getErrorMsg(error), 12000);
            setInDelete(false);
          });
        break;
      case 'idonea':
      case 'finanziabile':
      case 'non_finanziabile':
      case 'sospesa':
      case 'sospesa_terzo_accesso':
      case 'finanziabile_terzo_accesso':
      case 'non_finanziabile_terzo_accesso':
        richiestaService
          .rinunciaDomanda(richiestaId)
          .then(() => {
            getRichieste();
            toastContext.success('Domanda rinunciata con successo!', 6000);
            setModalOpen(false);
            setRichiestaId(null);
            setInDelete(false);
          })
          .catch((error) => {
            toastContext.error(utility.getErrorMsg(error), 12000);
            setInDelete(false);
          });
        break;
      default:
        break;
    }
  }

  const onNuovaRichiesta = (e) => {
    if (onCreateRichiesta) return;
    e.preventDefault();
    e.stopPropagation();
    setOnCreateRichiesta(true);
    richiestaService.create(null).then((resp) => {
      setOnCreateRichiesta(false);
      if (!resp) return;
      navigation(`/gestione-richiesta/${resp.id}`);
    }).catch((error) => {
      setOnCreateRichiesta(false);
      toastContext.error('Operazione non valida', 12000);
      console.log(error);
    });
  };

  const onEdit = (richiesta) => {
    navigation(`/gestione-richiesta/${richiesta.id}`);
  };

  const aggiornaFunction = (richiesta) => {
    navigation(richiesta.faseTipologia === 'RIAPERTURA_PRESENTAZIONE'
      ? `/rettifica-ripresentazione/${richiesta.id}`
      : `/aggiornamento-isee/${richiesta.id}`);
  };

  const secondoAccessoFunction = (richiesta) => {
    navigation(`/secondo-accesso/${richiesta.id}`);
  };

  const terzoAccessoFunction = (richiesta) => {
    navigation(`/terzo-accesso/${richiesta.id}`);
  };

  const getRichieste = () => {
    setRichiesteLoaded(false);
    const esiti = 
        esito === 'AGGIORNATA_SA'
            ? ['FINANZIABILE', 'NON_FINANZIABILE', 'SOSPESA', 'FINANZIABILE_TERZO_ACCESSO','FINANZIABILE_RETTIFICATA', 'NON_FINANZIABILE_TERZO_ACCESSO'] 
            : (esito==='AMMESSA_CONTRIBUTO')? ['AMMESSA_CONTRIBUTO','AMMESSA_CONTRIBUTO_RETTIFICATA'] : (esito)? [esito] : null;
    richiestaService.getAll({ 'Anno Scolastico': annoScolastico, 'Esiti': esiti }).then((resp) => {
      setRichieste(resp);
      setRichiesteLoaded(true);
    }).catch(error => {
      console.log(error);
      setRichiesteLoaded(true);
    });
  }

  const downloadPdf = async (richiestaId, richiestaCodice) => {
    const response = await richiestaService.downloadPdf(richiestaId, richiestaCodice);
    utility.downloadFile(response.data, `richiesta_${richiestaCodice}.pdf`);
  }

  const annullaDomanda = async (richiestaId) => {
    setRichiestaId(richiestaId);
    setTitle('Annulla domanda');
    setIcona(null);
    setIconaColor(null);
    setContent('Confermi di voler annullare la domanda presentata?\nAttenzione: se annulli questa domanda non potrai ripresentarne una nuova, perché la fase per la presentazione delle domande è conclusa. L\'annullamento comporterà l\'esclusione della tua domanda dal procedimento per ottenere il contributo');
    setCloseLabel('Annulla');
    setShowIcon(false);
    setHideActionButton(false);
    setModalOpen(true);
  }

  const showMotivazioneNonIdoneitaFunction = async (richiesta) => {
    const esitoIsee = "Motivazione non idoneità";
    const icona = "solid--x-circle";
    const iconaColor = "rtds-text-error-dark";
    setIcona(icona);
    setIconaColor(iconaColor);
    setTitle(esitoIsee);
    setShowIcon(true);
    setCloseLabel('Chiudi');
    setHideActionButton(true);
    setContent(richiesta?.motivazioneNonIdoneita);
    setModalOpen(true);
  }

  const iseeKoBtnFunction = async (richiesta) => {
    const esito = richiesta.esitoIsee;
    const esitoIsee = esito === "OK" ?  "Esito ISEE positivo" : "Esito ISEE negativo";
    const icona = esito === "OK" ?  "solid--face-smile" : "solid--face-frown";
    const iconaColor = esito === "OK" ?   "rtds-text-success-dark" : "rtds-text-warn-dark";
    setIcona(icona);
    setIconaColor(iconaColor);
    setTitle(esitoIsee);
    setShowIcon(true);
    setCloseLabel('Chiudi');
    setHideActionButton(true);
    setContent(
      <div>
        <section aria-labelledby='elencoErrori'>
          {esito === "KO" ? (
            <>
            <section aria-labelledby="elencoErrori">
              <h3 id="elencoErrori" className="rtds-heading-5">
                Lista errori ISEE:{" "}
              </h3>
              <ul>
                {
                  richiesta.erroriIsee
                    .map((errore) => (
                      <li key={errore.codice}>&#x2022;&nbsp;{errore.descrizione}</li>
                    ))
                }
              </ul>
            </section>
            <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>
            </>
          ) : null}
        </section>       
      </div>
    );

    setModalOpen(true);
  }

  const faseTerzoAccessoAttiva = fasi.find(f =>
    f.tipologia === 'TERZO_ACCESSO_SOSPESI' &&
    richieste.find(r => r.faseId === f.raccoltaDomande.id) &&
    utility.checkFaseIsActive(f)
  );

  const mostraAlertTerzoAccesso = richieste.some(r => {
    return (
            r.statoRichiesta?.toLowerCase() === "sospesa_terzo_accesso" ||
            r.statoRichiesta?.toLowerCase() === "finanziabile_terzo_accesso" ||
            r.statoRichiesta?.toLowerCase() === "non_finanziabile_terzo_accesso"
           ) &&
           faseTerzoAccessoAttiva;
  });

  const faseSecondoAccessoAttiva = fasi.find(f =>
    f.tipologia === 'SECONDO_ACCESSO_NON_AMMESSI_SOSPESI' &&  
    richieste.find(r => r.faseId === f.raccoltaDomande.id) &&
    utility.checkFaseIsActive(f)
  );

  const faseRettificaAttiva = fasi.find(f =>
    f.tipologia === 'AGGIORNAMENTO_ISEE' &&  
    richieste.find(r => r.faseId === f.raccoltaDomande.id) &&
    utility.checkFaseIsActive(f) 
  );

  const mostraAlertRettifica = richieste.some(r => r.statoRichiesta?.toLowerCase() === "presentata" && r.canBeUpdated) && faseRettificaAttiva;

  const mostraAlertSecondoAccesso = richieste.some(r => 
    (
      r.statoRichiesta?.toLowerCase() === "idonea" ||
      r.statoRichiesta?.toLowerCase() === "finanziabile" ||
      r.statoRichiesta?.toLowerCase() === "non_finanziabile" ||
      r.statoRichiesta?.toLowerCase() === "sospesa"
    ) &&
    faseSecondoAccessoAttiva &&
    r.canBeSecondoAccesso
  );

  return (
    <>
      <div className="rtds-container rtds-py-6">
        <div className="rtds-grid rtds-gap-6 xl:rtds-gap-8">
          <div className="border-l-4 rtds-border-primary pl-6 py-4">
            <p className="rtds-display-heading-5 rtds-mb-2">
              Con Libri Gratis vogliamo che la scuola sia una scuola davvero
              per tutti, senza barriere economiche.
            </p>
            <p className="rtds-display-heading-5 rtds-font-bold">
              La Regione Toscana: il diritto di studiare.
            </p>
            <div className="mt-4 text-right rtds-display-heading-6 font-bold rtds-content-02">
              — Eugenio Giani
            </div>
          </div>

          {
            (
              mostraAlertRettifica ||
              mostraAlertSecondoAccesso
            ) && (
              <AlertMessage
                title={"Attenzione!"}
                message={
                  mostraAlertRettifica
                    ? ("È attiva la fase '" + faseRettificaAttiva?.titolo + "' che permette di aggiornare i dati delle domande presentate fino al " + moment(faseRettificaAttiva?.dataFine).format('DD/MM/YYYY HH:mm:ss'))
                    : ("È attiva la fase '" + faseSecondoAccessoAttiva?.titolo + "' che permette di aggiornare i dati delle domande idonee fino al " + moment(faseSecondoAccessoAttiva?.dataFine).format('DD/MM/YYYY HH:mm:ss'))
                }
                classDiv={'rtds-text-warn-dark'}
                classArticle={''}
                iconName={'mini--exclamation-triangle'}
              >
              </AlertMessage>
            )
          }

          {
            mostraAlertTerzoAccesso &&
            <AlertMessage
              title={"Attenzione!"}
              message={`È attiva la fase "${faseTerzoAccessoAttiva?.titolo}“ che permette di aggiornare i dati delle domande sospese fino al ${moment(faseTerzoAccessoAttiva?.dataFine).format('DD/MM/YYYY HH:mm:ss')}.`}
              classDiv={'rtds-text-warn-dark'}
              classArticle={''}
              iconName={'mini--exclamation-triangle'}
            >
            </AlertMessage>
          }

          <div className="rtds-flex rtds-items-center rtds-justify-between">
            <h1 className="rtds-heading-2">Le mie domande</h1>
          </div>

          <FiltriAvanzati
            hidden={!canCreateLoaded || !richiesteLoaded}
            defaultOpen={false}
            mapFilters={currMapFilters}
            onRemoveFilter={(type) => onChangeFilter(type, null, new Map(nextMapFilters), new Map(nextAdvancedFiltersMap), true, true)}
            initialOpening={false}
          >
            <div className="rtds-grid rtds-gap-3">
              <div className="rtds-field-row">
                <Select
                  classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                  label={"Anno Scolastico"}
                  id={"Anno Scolastico"}
                  classSelect={""}
                  onChange={(event) =>
                    onChangeFilter(
                      "Anno Scolastico",
                      event.target.value ? event.target.value : null,
                      new Map(nextMapFilters),
                      new Map(nextAdvancedFiltersMap),
                      true
                    )
                  }
                  baseOption={"Nessuna selezione"}
                  options={anniScolastici}
                  bindValue={"value"}
                  bindKey={"key"}
                  value={annoScolastico || ""}
                />
                <Select
                  classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                  label={"Esito"}
                  id={"esito"}
                  classSelect={""}
                  onChange={(event) =>
                    onChangeFilter(
                      "Esito",
                      event.target.value ? event.target.value : null,
                      new Map(nextMapFilters),
                      new Map(nextAdvancedFiltersMap),
                      true
                    )
                  }
                  baseOption={"Nessuna selezione"}
                  options={esiti}
                  bindValue={"value"}
                  bindKey={"key"}
                  value={esito || ""}
                />
              </div>
              <div className="rtds-form-actions rtds-flex rtds-justify-start">
                <button
                  type="button"
                  className="rtds-btn rtds-btn--icon-right rtds-group/button rtds-btn--secondary"
                  onClick={() => {
                    onSearch();
                  }}
                >
                  Cerca
                  <svg
                    className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:rtds-translate-x-1"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                    />
                  </svg>
                </button>
              </div>
            </div>
          </FiltriAvanzati>
        </div>
      </div>

      <section className="rtds-grid rtds-gap-4" hidden={canCreateLoaded && richiesteLoaded}>
        <div
          className="rtds-empty-state rtds-grid rtds-gap-4"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="rtds-font-bold rtds-text-center rtds-grid rtds-gap-8 rtds-justify-center rtds-justify-items-center rtds-py-20">
            <svg
              className="rtds-icon rtds-fill-current rtds-w-16 rtds-h-16 rtds-animate-spin"
              aria-hidden="true"
              focusable="false"
              role="img"
            >
              <use 
               xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
              />
            </svg>
            <span className="rtds-sr-only">Caricamento...</span>

            <h3 className="rtds-heading-4">
              <div className="loading-message">
                Attendere un momento
                <span className="dots">...</span>
              </div>
            </h3>
          </div>
        </div>
      </section>

      <section className="rtds-section rtds-section--siti-web-collegati rtds-py-8 md:rtds-py-12" hidden={!canCreateLoaded || !richiesteLoaded}>
        <div className="rtds-container rtds-space-y-4">
          <div className="rtds-space-y-4">
            {!richieste?.length && !canCreate && (
              <div
                className="rtds-empty-state rtds-grid rtds-gap-4"
                aria-live="assertive"
                aria-atomic="true"
              >
                <div className="rtds-font-bold rtds-text-center rtds-grid rtds-gap-8 rtds-justify-center rtds-justify-items-center rtds-py-20">
                  <svg
                    className="rtds-icon rtds-fill-current rtds-w-16 rtds-h-16 rtds-content-03"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use href="../../icons.svg#outline--exclamation-circle" />
                  </svg>

                  <h3 className="rtds-heading-4">Nessuna domanda presente</h3>
                </div>
              </div>
            )}

            <ul
              role="list"
              className="rtds-grid rtds-gap-4 md:rtds-grid-cols-3"
            >
              <li className="rtds-col" hidden={!canCreate}>
                <a
                  style={{ minHeight: "250px" }}
                  className="rtds-bg-secondary-50 rtds-flex flex-col h-full rtds-card rtds-card--information rtds-card--information-left-icon 
                  rtds-group/card rtds-content-center rtds-btn--only-text"
                  onClick={onNuovaRichiesta}
                  href="#"
                >
                  <div className="flex-grow rtds-card__content flex-grow flex items-center justify-center h-full">
                    <div className="rtds-content-02 rtds-text-lg rtds-flex rtds-items-center rtds-gap-3 rtds-font-bold">
                      <svg
                        className="rtds-icon rtds-w-8 rtds-h-8"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--plus-circle`}
                        />
                      </svg>
                      Presenta domanda
                    </div>
                  </div>
                </a>
              </li>

              {
                richieste.map(card => {
                  return (
                    <li key={card.codice} className="rtds-col">
                      <Card
                        card={card}
                        editFunction={onEdit}
                        deleteFunction={eliminaRichiesta}
                        renounceFunction={rinunciaRichiesta}
                        pdfFunction={downloadPdf}
                        rejectFunction={annullaDomanda}
                        iseeKoBtnFunction={iseeKoBtnFunction}
                        aggiornaFunction={aggiornaFunction}
                        secondoAccessoFunction={secondoAccessoFunction}
                        terzoAccessoFunction={terzoAccessoFunction}
                        showMotivazioneNonIdoneitaFunction={showMotivazioneNonIdoneitaFunction}
                      />
                    </li>
                  );
                })
              }
            </ul>
          </div>
        </div>
      </section>

      <Modal
        isOpen={isModalOpen}
        title={title}
        content={content}
        onClose={() => setModalOpen(false)}
        onAction={handleModalAction}
        actionLabel="Conferma"
        closeLabel={closeLabel}
        confirmLoading={inDelete}
        disabledConfirmBtn={inDelete}
        disableCloseBtn={inDelete}
        iconaClass={icona}
        icona={showIcon}
        iconaColorClass={iconaColor}
        hideActionButton={hideActionButton}
      />
    </>
  );
};

export default Dashboard;
